// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__W5o5s","type":"styles_type__2OKhn","choices":"styles_choices__27Mlw"};